import { render, staticRenderFns } from "./OthersAgreements.vue?vue&type=template&id=dedded5e&"
import script from "./OthersAgreements.vue?vue&type=script&lang=js&"
export * from "./OthersAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports